const env = import.meta.env as Record<string, string | undefined>;

const getEnvValue = (key: string, fallback = ''): string => {
  const value = env[key];

  if (typeof value === 'string' && value.trim() !== '') {
    return value;
  }

  return fallback;
};

const parseCsv = (value: string): string[] => {
  if (!value) {
    return [];
  }

  return value
    .split(',')
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean);
};

export const appEnv = {
  firebase: {
    apiKey: getEnvValue('VITE_FIREBASE_API_KEY'),
    authDomain: getEnvValue('VITE_FIREBASE_AUTH_DOMAIN'),
    projectId: getEnvValue('VITE_FIREBASE_PROJECT_ID'),
    storageBucket: getEnvValue('VITE_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: getEnvValue('VITE_FIREBASE_MESSAGING_SENDER_ID'),
    appId: getEnvValue('VITE_FIREBASE_APP_ID'),
    measurementId: getEnvValue('VITE_FIREBASE_MEASUREMENT_ID'),
  },
  auth: {
    allowedEmails: parseCsv(getEnvValue('VITE_ALLOWED_EMAILS', getEnvValue('VITE_ADMIN_ALLOWED_EMAILS'))),
  },
  admin: {
    allowedEmails: parseCsv(getEnvValue('VITE_ADMIN_ALLOWED_EMAILS')),
  },
  cloudinary: {
    cloudName: getEnvValue('VITE_CLOUDINARY_CLOUD_NAME'),
    apiKey: getEnvValue('VITE_CLOUDINARY_API_KEY'),
    uploadPreset: getEnvValue('VITE_CLOUDINARY_UPLOAD_PRESET'),
    folder: getEnvValue('VITE_CLOUDINARY_UPLOAD_FOLDER', 'contacts'),
  },
};
